import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import {
    ResultStatus,
} from "../../constants/appConstant";
import { AppCheckBox } from "../../components/appComponents";
import CardSnippet from "../../components/ui/card-snippet";
import { CardContent } from "../../components/ui/card";
import { AppSearchSelect } from "../../components/appComponents";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MasterPermissions = () => {
    const navigate = useNavigate();
    const [clubList, setClubList] = useState([]);
    const [permissionsList, setPermissionsList] = useState([]);
    const [defaultPermissionsList, setDefaultPermissionsList] = useState([]);
    const [selectedClub, setSelectedClub] = useState(null);
    const [selectedClubId, setSelectedClubId] = useState(null);
    const [checkedPermissions, setCheckedPermissions] = useState(new Set());
    const [saving, setSaving] = useState(false);
    // const [defaultViewId, setDefaultViewId] = useState(null);
    const [menuTabs, setMenuTabs] = useState([]);

    useEffect(() => {
        getClubAccount();
        getMenuTabs();
        getDefaultPermissions();
        //getPermissions();
    }, []);

    const getClubAccount = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetClubsDDL"
            );
            const data = response?.data ?? [];
            setClubList(data);

            // Do NOT auto-select first club
            setSelectedClub(null);
            setSelectedClubId(null);
            setPermissionsList([]);
            setCheckedPermissions(new Set());
        });
    };
    const getMenuTabs = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetMenuTabs"
            );
            const data = response?.data ?? [];
            setMenuTabs(data);
        });
    };

    const getDefaultPermissions = async (isRoutePage = false) => {
        const response = await Common.ApiService.getInstance().request(
            `GetDefaultMasterPermissions?isRoutePage=${isRoutePage}`,
            "GET"
        );
        debugger
        const _data = response?.data ?? [];
        setDefaultPermissionsList(_data);
        // console.log(_data, 'defualt permissions');
        // const defaultView = _data.find(p => p.isdefaultview === 1);
        // setDefaultViewId(defaultView ? defaultView.id : null);
    };

    const sanitizeCheckedPermissions = (set) => {
        const validIds = new Set();
        set.forEach(id => {
            // Only include IDs that exist in permissionsList or defaultPermissionsList
            if (
                permissionsList.find(p => p.id === id) ||
                defaultPermissionsList.find(p => p.id === id)
            ) {
                validIds.add(id);
            }
        });
        return validIds;
    };

    const getPermissionsForClub = async (clubId = null) => {
        let queryParams = [];

        if (clubId) queryParams.push(`clubId=${clubId}`);
        // if (roleId) queryParams.push(`roleId=${roleId}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

        const response = await Common.ApiService.getInstance().request(
            `GetDefaultClubPermissions${queryString}`,
            "GET"
        );
        const _data = response?.data ?? [];
        setPermissionsList(_data);

        // Update defaultPermissionsList with fetched data
        setDefaultPermissionsList((prev) => {
            const updated = prev.map(dp => {
                const match = _data.find(p => p.id === dp.id);
                return match ? { ...dp, premiumallowed: match.premiumallowed } : dp;
            });
            return updated;
        });
        // Identify the checked IDs
        const checkedIds = new Set(_data.map(p => p.id));
        // Build a sanitized set of checked permissions
        const sanitizedCheckedIds = sanitizeCheckedPermissions(checkedIds);
        setCheckedPermissions(sanitizedCheckedIds);


        // const defaultView = _data.find(p => p.isdefaultview == 1);
        // setDefaultViewId(defaultView ? defaultView.id : null);

    };

    // Handle individual checkbox change
    const handlePermissionChange = (permissionId, isChecked) => {
        const newCheckedPermissions = new Set(checkedPermissions);

        if (isChecked) {
            newCheckedPermissions.add(permissionId);
        } else {
            newCheckedPermissions.delete(permissionId);

            // Clear defaultview and premiumallowed on unselect
            const updated = permissionsList.map(p => {
                if (p.id === permissionId) {
                    return {
                        ...p,
                        // isdefaultview: 0,
                        premiumallowed: null,
                    };
                }
                return p;
            });
            setPermissionsList(updated);

            // If the unselected permission was the default view, clear defaultViewId
            // if (defaultViewId === permissionId) {
            //     setDefaultViewId(null);
            // }
        }

        setCheckedPermissions(newCheckedPermissions);
    };


    const handleFlagChange = (id, flag, value) => {
        const updated = permissionsList.map((p) =>
            p.id === id ? { ...p, [flag]: value } : p
        );
        setPermissionsList(updated);
    };

    // Handle parent checkbox change (recursive)
    const handleParentPermissionChange = (node, isChecked) => {
        const newCheckedPermissions = new Set(checkedPermissions);

        // Function to recursively add/remove node and all children
        const updateNodeAndChildren = (currentNode, checked) => {
            if (checked) {
                newCheckedPermissions.add(currentNode.id);
            } else {
                newCheckedPermissions.delete(currentNode.id);
            }

            // Recursively handle children
            if (currentNode.children && currentNode.children.length > 0) {
                currentNode.children.forEach(child => {
                    updateNodeAndChildren(child, checked);
                });
            }
        };

        updateNodeAndChildren(node, isChecked);
        setCheckedPermissions(newCheckedPermissions);
    };

        // Save permissions function
        const savePermissions = async () => {
            debugger
            if (!selectedClub) {
                Common.showToast("Please select a club first.", "Warning", "warning");
                return;
            }
            if (checkedPermissions.size === 0) {
                Common.showToast("Please select at least one permission.", "Warning", "warning");
                return;
            }
            // Prepare data for API call
            const menuData = Array.from(checkedPermissions).map((menuId) => {
                console.log(permissionsList, "permissionlist");
                const permission = permissionsList.find((p) => p.id === menuId);
                return {
                    id: menuId,
                    premiumallowed:
                        typeof permission?.premiumallowed === "boolean"
                            ? permission.premiumallowed
                            : null,
                };
            });
    
            if (!menuData.length) {
                Common.showToast("Please select at least one permission.", "Warning", "warning");
                return;
            }
            const premiumWithoutSelection = Array.from(checkedPermissions)
                .map(id => defaultPermissionsList.find(p => p.id === id))
                .filter(p => p?.ispremium && p.premiumallowed === null);
    
            if (premiumWithoutSelection.length > 0) {
                Common.showToast(
                    "Please select Yes or No for selected premium permissions.", "Warning", "warning");
                return;
            }
            setSaving(true);
    
            try {
                const payload = {
                    clubid: selectedClubId,
                    // roleid: RoleEnum.Club_Manager,
                    // defaultviewId: defaultViewId,
                    menuData,
                };
    
                // Option 1: Using batch save (recommended)
                const response = await Common.ApiService.getInstance().request(
                    "SaveMasterPermissions",
                    payload,
                    "POST"
                );
    
                if (response.status === ResultStatus.Success || response.success) {
                    Common.showToast("Permissions saved successfully!", "Success", "success");
                } else {
                    Common.showToast("Error saving permissions: " + (response.message || "Unknown error", "Error", "error"));
                }
    
            } catch (error) {
                console.error("Error saving permissions:", error);
                Common.showToast("Error saving permissions: " + error.message, "Error", "error");
            } finally {
                setSaving(false);
            }
        };

    const buildPermissionTree = (flatList) => {
        const map = {};
        const tree = [];

        flatList.forEach((item) => {
            map[item.id] = { ...item, children: [] };
        });

        flatList.forEach((item) => {
            if (item.parentId && map[item.parentId]) {
                map[item.parentId].children.push(map[item.id]);
            } else {
                tree.push(map[item.id]);
            }
        });

        const sortByOrder = (list) => {
            return list
                .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                .map((node) => ({
                    ...node,
                    children: sortByOrder(node.children),
                }));
        };

        return sortByOrder(tree);
    };

    //Helper function to count children recursively
    const countChildren = (node) => {
        if (!node.children || node.children.length === 0) {
            return 0;
        }

        let count = node.children.length;
        node.children.forEach(child => {
            count += countChildren(child);
        });

        return count;
    };

    // Check if all children are selected
    const areAllChildrenSelected = (node) => {
        if (!node.children || node.children.length === 0) {
            return checkedPermissions.has(node.id);
        }

        return node.children.every(child =>
            checkedPermissions.has(child.id) && areAllChildrenSelected(child)
        );
    };

    // Check if some children are selected (for indeterminate state)
    const areSomeChildrenSelected = (node) => {
        if (!node.children || node.children.length === 0) {
            return false;
        }

        return node.children.some(child =>
            checkedPermissions.has(child.id) || areSomeChildrenSelected(child)
        );
    };

    const renderPermissions = (nodes, level = 0) => {
        return nodes.map((node) => {
            const paddingStyle = {
                paddingLeft: `${level * 20}px`,
            };

            const childCount = countChildren(node);
            const premiumLabel = node.ispremium ? " (Premium Feature)" : "";
            const displayText =
                childCount > 0
                    ? `${node.name} ---------------- (${childCount})${premiumLabel}`
                    : `${node.name}${premiumLabel}`;

            const isChecked = checkedPermissions.has(node.id);
            const hasChildren = node.children && node.children.length > 0;
            const allChildrenSelected = hasChildren
                ? areAllChildrenSelected(node)
                : false;
            const someChildrenSelected = hasChildren
                ? areSomeChildrenSelected(node)
                : false;

            const updateNodeValue = (nodeId, key, value) => {
                setPermissionsList((prev) => {
                    const exists = prev.some((node) => node.id === nodeId);

                    if (exists) {
                        return prev.map((node) =>
                            node.id === nodeId ? { ...node, [key]: value } : node
                        );
                    } else {
                        // Try to find the node in defaultPermissionsList (or anywhere else you trust)
                        const nodeFromDefaults = defaultPermissionsList.find(n => n.id === nodeId);
                        if (nodeFromDefaults) {
                            return [...prev, { ...nodeFromDefaults, [key]: value }];
                        }

                        // If not found anywhere, add a minimal object
                        return [...prev, { id: nodeId, [key]: value }];
                    }
                });

                // Also update defaultPermissionsList if needed
                setDefaultPermissionsList((prev) =>
                    prev.map((node) =>
                        node.id === nodeId ? { ...node, [key]: value } : node
                    )
                );
            };


            return (
                <div
                    key={node.id}
                    className="py-1 flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-dashed border-gray-200"
                >
                    {/* Left: Permission checkbox */}
                    <div className="flex items-center gap-2 w-full sm:w-3/4" style={paddingStyle}>
                        <AppCheckBox
                            text={displayText}
                            checked={hasChildren ? allChildrenSelected : isChecked}
                            indeterminate={hasChildren && someChildrenSelected && !allChildrenSelected}
                            onChange={(checked) => {
                                if (hasChildren) {
                                    handleParentPermissionChange(node, checked);
                                } else {
                                    handlePermissionChange(node.id, checked);
                                }
                            }}
                            className="border-default-300"
                        />
                    </div>

                    {/* Right: Default view toggle (radio-style) */}
                    {/* Premium Allowed (Only if ispremium is true) - Show for all premium nodes, including parents */}
                    {node.ispremium && (
                        <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mt-2 sm:mt-0 pl-4">
                            <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-600 font-medium">Premium Allowed:</span>
                                <label className="flex items-center gap-1">
                                    <input
                                        type="radio"
                                        name={`premium-${node.id}`}
                                        checked={
                                            (permissionsList.find(p => p.id === node.id)?.premiumallowed) === true
                                        }
                                        onChange={() => {
                                            // select the item if not selected
                                            if (!checkedPermissions.has(node.id)) {
                                                const newChecked = new Set(checkedPermissions);
                                                newChecked.add(node.id);
                                                setCheckedPermissions(newChecked);
                                            }
                                            updateNodeValue(node.id, "premiumallowed", true);
                                        }}
                                        className="form-radio h-4 w-4"
                                    />
                                    <span className="text-xs">Yes</span>
                                </label>
                                <label className="flex items-center gap-1">
                                    <input
                                        type="radio"
                                        name={`premium-${node.id}`}
                                        checked={
                                            (permissionsList.find(p => p.id === node.id)?.premiumallowed) === false
                                        }
                                        onChange={() => {
                                            // select the item if not selected
                                            if (!checkedPermissions.has(node.id)) {
                                                const newChecked = new Set(checkedPermissions);
                                                newChecked.add(node.id);
                                                setCheckedPermissions(newChecked);
                                            }
                                            updateNodeValue(node.id, "premiumallowed", false);
                                        }}
                                        className="form-radio h-4 w-4"
                                    />
                                    <span className="text-xs">No</span>
                                </label>
                            </div>
                        </div>
                    )}


                    {/* Recursively render children */}
                    {hasChildren && (
                        <div className="w-full">{renderPermissions(node.children, level + 1)}</div>
                    )}
                </div>
            );
        });
    };

    const permissionTree = buildPermissionTree(defaultPermissionsList);

    // Add select all state logic
    const allPermissionIds = defaultPermissionsList.map(p => p.id);
    const isAllSelected = allPermissionIds.length > 0 && allPermissionIds.every(id => checkedPermissions.has(id));
    const isIndeterminate = checkedPermissions.size > 0 && !isAllSelected;

    const handleSelectAllChange = (checked) => {
        if (checked) {
            setCheckedPermissions(new Set(allPermissionIds));
        } else {
            setCheckedPermissions(new Set());
        }
    };

    return (
        <>
            <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
                <AppSearchSelect
                    value={selectedClub}
                    onChange={async (val) => {
                        await setSelectedClub(val);
                        await setSelectedClubId(val);
                        await getPermissionsForClub(val)

                    }}
                    placeholder="Select Club"
                    label={"Clubs"}
                    data={clubList}
                    className={"mb-3 col-span-1"}
                />

                <Button className="lg:mt-6 h-8 mb-5" onClick={() => navigate(`/app/addroutes`)}>
                    Add Routes
                </Button>
            </div>
            <div className="flex flex-col gap-2">
                <CardSnippet
                    title="Master Permissions"
                    addButton={() => (
                        <Button className="h-8" onClick={savePermissions}
                            disabled={saving || !selectedClub}>
                            Save Permissions
                        </Button>
                    )}
                >
                    <CardContent className="p-4">
                        {/* Select All Checkbox */}
                        <div className="mb-4">
                            <AppCheckBox
                                 text={<span className="font-bold text-md">Select All Permissions</span>}                                
                                 checked={isAllSelected}
                                 indeterminate={isIndeterminate}
                                 onChange={handleSelectAllChange}
                                 className="border-default-300 w-6 h-6"
                            />
                        </div>
                        <hr className="border-gray-300 mb-4" />
                        <div className="space-y-3">{renderPermissions(permissionTree)}</div>
                    </CardContent>
                </CardSnippet>
            </div>

            {/* Initialize the dialog */}
            {/* <AddRolesByClub
                open={open
                setOpen={setOpen}
                onClose={handleClose}
                clubId={selectedClubId}
            /> */}
        </>
    );
};


export default MasterPermissions;